import { useQuery } from '@tanstack/react-query';
import { storefrontApiRequest, PRODUCTS_QUERY, type ShopifyProduct } from '@/lib/shopify';
import { supabase } from '@/integrations/supabase/client';

export function useShopifyProducts(count: number = 50, query?: string) {
  const { data, isLoading: loading, error } = useQuery({
    queryKey: ['shopify-products', count, query ?? null],
    queryFn: async () => {
      const [shopifyData, { data: inactiveProducts }] = await Promise.all([
        storefrontApiRequest(PRODUCTS_QUERY, {
          first: count,
          query: query || null,
        }),
        supabase.from('products').select('slug').eq('is_active', false),
      ]);

      const inactiveSlugs = new Set(
        (inactiveProducts || []).map((p) => p.slug.toLowerCase())
      );

      if (shopifyData?.data?.products?.edges) {
        return shopifyData.data.products.edges.filter(
          (edge: ShopifyProduct) => !inactiveSlugs.has(edge.node.handle.toLowerCase())
        ) as ShopifyProduct[];
      }
      return [] as ShopifyProduct[];
    },
    staleTime: 2 * 60_000, // products change infrequently — 2 min cache
  });

  return {
    products: data ?? [],
    loading,
    error: error instanceof Error ? error.message : (error ? 'Failed to load products' : null),
  };
}
